import { render, staticRenderFns } from "./ContactComponent.vue?vue&type=template&id=87e93b60&scoped=true&"
import script from "./ContactComponent.vue?vue&type=script&lang=js&"
export * from "./ContactComponent.vue?vue&type=script&lang=js&"
import style0 from "./ContactComponent.vue?vue&type=style&index=0&id=87e93b60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e93b60",
  null
  
)

export default component.exports